export default __webpack_public_path__ + "static/media/privacy.6a6704ec.svg";